import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { label: "Tentang Kursus", href: "#tentang" },
  { label: "Syarat", href: "#syarat" },
  { label: "Lokasi", href: "#lokasi" },
];

const scrollTo = (href) => {
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export function KursusHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="kursus-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-kursus-bg/95 backdrop-blur-md border-b border-kursus-gold/40 py-2.5" : "bg-black/20 py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <div className="flex items-center gap-2.5 min-w-0">
          <img src="/piks-logo.png?v=7" alt="Bodyguard Sarawak" className="h-9 w-9 sm:h-10 sm:w-10 object-contain shrink-0" />
          <div className="min-w-0">
            <div className="font-oswald text-sm sm:text-base font-bold tracking-wide text-kursus-white truncate">BODYGUARD SARAWAK</div>
            <div className="hidden sm:block text-[10px] text-kursus-muted tracking-wide truncate">Persatuan Pengawal Peribadi Sarawak</div>
          </div>
        </div>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((n) => (
            <button
              key={n.href}
              data-testid={`kursus-nav-${n.href.slice(1)}`}
              onClick={() => scrollTo(n.href)}
              className="font-oswald text-sm tracking-wide text-kursus-white/80 hover:text-kursus-gold transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <Button
          data-testid="kursus-header-cta"
          onClick={() => scrollTo("#daftar")}
          className="bg-kursus-gold text-black hover:bg-kursus-red hover:text-white font-oswald font-bold tracking-wide rounded-full px-4 sm:px-6 text-xs sm:text-sm transition-colors"
        >
          DAFTAR SEKARANG
        </Button>
      </div>
    </header>
  );
}
